import React from 'react';
import PropTypes from 'prop-types';
import CRC from 'js-crc';

const DATA_ATTRIBUTE = 'data-woff-embedded-name';

export default {
  propTypes: {
    woff: PropTypes.string,
  },

  componentWillMount() {
    this.addFontFaceDeclaration(this.props);
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.woff !== this.props.woff) {
      this.addFontFaceDeclaration(nextProps);
    }
  },

  addFontFaceDeclaration(props) {
    if (props.woff) {
      const oldName = this._name;
      const newName = CRC.crc32(props.woff).toString();
      const style = document.querySelector(`[${DATA_ATTRIBUTE}="${oldName || newName}"]`) || document.createElement('style');

      this._name = newName;

      if (oldName !== newName) {
        style.innerText = this.fontFaceDeclaration(props);
        style.setAttribute(DATA_ATTRIBUTE, this._name);
      }

      if (!style.parentNode) {
        document.querySelector('head').appendChild(style);
      }
    }
  },

  fontFaceDeclaration(props) {
    return (
      '@font-face {' +
      `  font-family: '${this._name}';` +
      `  src: url(data:application/x-font-woff;charset=utf-8;base64,${props.woff}) format('woff');` +
      '}'
    );
  },
};



// WEBPACK FOOTER //
// ./app/javascript/mixins/WoffEmbeddedMixin.js